import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ValueSliderDirective } from '@frontend/sports/common/ui/value-slider';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { ShowInEpcotDirective } from '../common/epcot-config.directive';
import { BaseballScoreboardComponent } from './components/baseball-scoreboard.component';
import { CricketScoreboardComponent } from './components/cricket-scoreboard.component';
import { DartsScoreboardComponent } from './components/darts-scoreboard.component';
import { GridScoreboardComponent } from './components/grid-scoreboard.component';
import { LeaderboardGameScoreboardComponent } from './components/leaderboard-game-scoreboard.component';
import { PairGameScoreboardComponent } from './components/pair-game-scoreboard.component';
import { PenaltyShootoutComponent } from './components/penalty-shootout.component';
import { PeriodGameScoreboardComponent } from './components/period-game-scoreboard.component';
import { DartsScoreboardHeaderComponent } from './components/scoreboard-headers/darts-scoreboard-header.component';
import { GridEventScoreboardHeaderComponent } from './components/scoreboard-headers/grid-scoreboard-header.component';
import { SetGameScoreboardHeaderComponent } from './components/scoreboard-headers/set-game-scoreboard-header.component';
import { SnookerScoreboardHeaderComponent } from './components/scoreboard-headers/snooker-scoreboard-header.component';
import { SetGameScoreboardComponent } from './components/set-game-scoreboard.component';
import { SnookerScoreboardComponent } from './components/snooker-scoreboard.component';

@NgModule({
    imports: [
        CommonModule,
        ValueSliderDirective,
        ShowInEpcotDirective,
        IconCustomComponent,
        BaseballScoreboardComponent,
        CricketScoreboardComponent,
        DartsScoreboardComponent,
        GridScoreboardComponent,
        LeaderboardGameScoreboardComponent,
        PairGameScoreboardComponent,
        PenaltyShootoutComponent,
        PeriodGameScoreboardComponent,
        SetGameScoreboardComponent,
        SnookerScoreboardComponent,
        GridEventScoreboardHeaderComponent,
        DartsScoreboardHeaderComponent,
        SnookerScoreboardHeaderComponent,
        SetGameScoreboardHeaderComponent,
    ],
    exports: [GridScoreboardComponent, GridEventScoreboardHeaderComponent],
})
export class GridScoreboardModule {}
